/**
 * @generated SignedSource<<5811d67a907a91ca4fb76ee97f88521e>>
 * @relayHash 2b72b669c483e855e067e2a3a66b5dc2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b72b669c483e855e067e2a3a66b5dc2

import { ConcreteRequest } from 'relay-runtime';
export type deAuditQuery$variables = {
  fromDate?: any | null;
  patientId: string;
  toDate?: any | null;
};
export type deAuditQuery$data = {
  readonly auditEvents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly action: string;
        readonly eventTime: string;
        readonly jsonPayload: string | null;
        readonly userName: string;
      };
    }> | null;
  } | null;
};
export type deAuditQuery = {
  response: deAuditQuery$data;
  variables: deAuditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toDate"
},
v3 = [
  {
    "alias": "auditEvents",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      },
      {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
      },
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      },
      {
        "kind": "Variable",
        "name": "toDate",
        "variableName": "toDate"
      }
    ],
    "concreteType": "AuditEventConnection",
    "kind": "LinkedField",
    "name": "de_auditEvents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuditEventEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuditEvent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "action",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jsonPayload",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deAuditQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deAuditQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "2b72b669c483e855e067e2a3a66b5dc2",
    "metadata": {},
    "name": "deAuditQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "62ea3e760e763820acdc7f2e605cf6b2";

export default node;
